import { Link } from 'react-router-dom';
import type { Alert } from '../api/types';
import { StatusDot } from './StatusDot';

export function Annunciator({ alerts }: { alerts: Alert[] }) {
  if (alerts.length === 0) return null;
  return (
    <div className="border-t border-cockpit-crit/40 bg-cockpit-crit/5">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-2 px-6 py-2 text-xs">
        <span className="text-[10px] uppercase tracking-widest text-cockpit-crit">Active</span>
        {alerts.slice(0, 6).map((a) => (
          <Link
            key={a.id}
            to="/alerts"
            className={
              a.severity === 'crit'
                ? 'flex items-center gap-1.5 rounded border border-cockpit-crit bg-cockpit-bg px-2 py-0.5 text-cockpit-crit hover:bg-cockpit-crit/10'
                : 'flex items-center gap-1.5 rounded border border-cockpit-warn bg-cockpit-bg px-2 py-0.5 text-cockpit-warn hover:bg-cockpit-warn/10'
            }
          >
            <StatusDot tone={a.severity} pulse={a.severity === 'crit'} />
            <span>{a.title}</span>
          </Link>
        ))}
        {alerts.length > 6 && (
          <Link to="/alerts" className="text-cockpit-dim hover:text-cockpit-text">
            +{alerts.length - 6} more
          </Link>
        )}
      </div>
    </div>
  );
}
